// @ts-check
import { CartAddEvent } from '@theme/events';

/**
 * @typedef {Object.<string, string>} SectionsHTML
 */

class CartNotification extends HTMLElement {
  /** @type {HTMLElement|null} */
  notificationProducts = null;

  /** @type {HTMLElement|null} */
  notificationModal = null;

  constructor() {
    super();
    this.#handleCartAdd = /** @type {any} */ (this.#handleCartAdd).bind(this);
  }

  connectedCallback() {
    /** @type {HTMLElement|null} */
    const products = this.querySelector('#cart-notification-product');
    this.notificationProducts = products;

    this.notificationModal = this.closest('#cart-notification-modal');

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * @param {string} html
   * @param {string|number} variantId
   * @returns {HTMLTableRowElement|null}
   */
  findCartRowInHTML(html, variantId) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const id = String(variantId);
    /** @type {Element|null} */
    const el = doc.querySelector(
      `tr[ref="cartItemRows[]"][data-variant-id="${id}"]`
    );
    return /** @type {HTMLTableRowElement|null} */ (el);
  }

  /**
   * @param {SectionsHTML|undefined|null} sections
   * @param {string|number} variantId
   * @returns {HTMLTableRowElement|null}
   */
  findVariantRowInSections(sections, variantId) {
    if (!sections) return null;
    for (const html of Object.values(sections)) {
      const row = this.findCartRowInHTML(html, variantId);
      if (row) return row;
    }
    return null;
  }

  /**
   * @param {CustomEvent<{ sourceId: string | number, data?: { sections?: SectionsHTML } }>} event
   */
  #handleCartAdd = (event) => {
    if (window.innerWidth >= 768) return;

    const detail = event?.detail;
    if (!detail) return;

    const sourceId = String(detail.sourceId);
    const sections = detail.data?.sections;

    const addedItem = this.findVariantRowInSections(sections, sourceId);
    if (!addedItem) return;

    if (this.notificationProducts) {
      this.notificationProducts.innerHTML = addedItem.outerHTML;
    }

    const count = this.cartCount;
    const countEl = this.notificationCartCount;
    if (countEl && typeof count === 'string') {
      const incrementedCount = Number(count) + 1;
      countEl.innerHTML = `(${incrementedCount})`;
    }

    // @ts-ignore - open may exist on custom elements
    this.notificationModal?.open?.();
  };

  /** @returns {HTMLElement|null} */
  get notificationCartCount() {
    return /** @type {HTMLElement|null} */ (
      this.querySelector('#notifications-cart-count')
    );
  }

  /** @returns {string|null|undefined} */
  get cartCount() {
    const el = /** @type {HTMLElement|null} */ (
      document.querySelector('.cart-bubble__text-count')
    );
    return el?.innerHTML?.trim();
  }
}

customElements.define('cart-notification', CartNotification);
